(function($){
    'use strict';

    var ajaxurl = OBJ.ajax_url;

    isotope_init();
    var filters = {};


    function isotope_init() {

        if ($('.js-radio-button-group').length && $('.wrapper-services-grid').length ) {

            $.urlParam = function(name){
                var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
                if (results==null){
                    return null;
                }
                else{
                    return results[1] || 0;
                }
            }

            // Initialise Isotope
            // Set the item selector
            var buttonFilter = '*';
            var services_cat = decodeURIComponent($.urlParam('cat'));
            // fix for block google ads
            if (services_cat == 'google-ads') {
                services_cat = 'googleservices';
            }

            // console.log ('cat-' + services_cat);
            if (services_cat != 'null' ){
                buttonFilter = '.' + services_cat;
            }

            // console.log ('buttonFilter-' + buttonFilter);

            var $services_grid = $('.wrapper-services-grid').isotope({
                // options
                itemSelector: '.services-item',
                layoutMode: 'fitRows',
                filter: buttonFilter
            });


            $('.js-radio-button-group .button').on('click', function (e) {
                if (!$(this).hasClass('is-checked')) {
                    $('.js-radio-button-group .button').removeClass('is-checked');
                    $(this).addClass('is-checked');

                    if ($(this).data('filter') == '*') {
                        var data_filter = $(this).data('filter');
                    } else {
                        var data_filter = '.' + $(this).data('filter');
                    }


                    $('.services-cat-select').val($(this).data('filter')).trigger('change.select2');

                    window.history.replaceState({}, document.title, location.protocol + '//' + location.host + location.pathname);
                    $services_grid = $('.wrapper-services-grid').isotope({filter: data_filter});
                }
            });


            $('.services-cat-select').on('change', function() {
                if ($(this).val() == '*') {
                    var select_filter = '';
                } else {
                    var select_filter = '.' + $(this).val();
                }

                $('.js-radio-button-group .button').removeClass('is-checked');
                $('.js-radio-button-group .button[data-filter="'+$(this).val()+'"]').addClass('is-checked');

                var $buttonGroup = $(this).parents('.services-filters-mobile');
                var filterGroup = $buttonGroup.attr('data-filter-group');

                filters[ filterGroup ] = $(this).val();
                var filterValue = concatValues( filters );
                console.log(filterValue);

                window.history.replaceState({}, document.title, location.protocol + '//' + location.host + location.pathname);
                $services_grid = $('.wrapper-services-grid').isotope({filter: filterValue});
            })

        }

        function concatValues( obj ) {
            var value = '';
            for ( var prop in obj ) {
                if (obj[ prop ] == '*') {
                    value += '';
                } else {
                    value += '.' + obj[ prop ];
                }
            }
            return value;
        }


        if ($('.js-radio-button-group').length && $('.wrapper-blog-grid').length ) {

            $.urlParam = function(name){
                var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
                if (results==null){
                    return null;
                } else {
                    return results[1] || 0;
                }
            }

            // Initialise Isotope
            // Set the item selector
            var buttonFilter = '*';
            var services_cat = decodeURIComponent($.urlParam('cat'));
            // console.log ('cat-' + services_cat);
            if (services_cat != 'null' ){
                buttonFilter = '.' + services_cat;
            }

            // console.log ('buttonFilter-' + buttonFilter);

            var $services_grid = $('.wrapper-blog-grid').isotope({
                // options
                itemSelector: '.blog-grid-item',
                layoutMode: 'fitRows',
                filter: buttonFilter
            });


            $('.js-radio-button-group .button').on('click', function (e) {
                if (!$(this).hasClass('is-checked')) {

                    $('.wrapper-blog-grid').isotope( 'remove', $('.blog-grid-item')).isotope('layout');

                    $('.wrapper-blog-grid').html('');

                    $('.wrapper-blog-grid').attr('data-page', '1');

                    $('.js-radio-button-group .button').removeClass('is-checked');
                    $(this).addClass('is-checked');

                    if ($(this).data('filter') == '*') {
                        var data_filter = $(this).data('filter');
                    } else {
                        var data_filter = '.' + $(this).data('filter');
                    }

                    // console.log(data_filter);

                    $('.services-cat-select').val($(this).data('filter')).trigger('change.select2');

                    window.history.replaceState({}, document.title, location.protocol + '//' + location.host + location.pathname);
                    $services_grid = $('.wrapper-blog-grid').isotope({filter: data_filter});


                    // add
                    var scrollLoadFlag = true;
                    var blog_category = $('.services-cat-select').val();
                    var data_page = '0';

                    var data = {
                        'action' : 'load_more_post',
                        'blog_category' : blog_category,
                        'data_page' : data_page
                    };

                    // console.log (data);

                    $.ajax({
                        url: ajaxurl,
                        method: 'POST',
                        data: data,
                        dataType: "json",
                        success: function (response) {

                            if (response.success) {

                                if (response.data.html) {
                                    if(response.data.page == '1') {
                                        // $('.wrapper-blog-grid').html(response.data.html);
                                    } else {
                                        // $('.wrapper-blog-grid').append(response.data.html);
                                    }

                                    /*
                                    $('.wrapper-blog-grid').isotope('destroy');

                                    $('.wrapper-blog-grid').isotope({
                                        // options
                                        itemSelector: '.blog-grid-item',
                                        layoutMode: 'fitRows',
                        
                                    });
                                    */

                                    var $newItems = $(response.data.html);
                                    setTimeout(function() {
                                        $('.wrapper-blog-grid').append( $newItems ).isotope( 'appended', $newItems ).isotope( 'layout' );
                                    }, 50); // fixes an overlay bug


                                    // $('.wrapper-blog-grid').append(response.data.html).isotope('appended',response.data.html);

                                    $('.wrapper-blog-grid').attr('data-page', response.data.page);



                                }
                            } else {

                            }
                        },
                        error: function (jqXHR) {
                            console.warn(jqXHR);
                        }
                    });


                }
            });

            $('.services-cat-select').on('change', function() {


                $('.wrapper-blog-grid').isotope( 'remove', $('.blog-grid-item')).isotope('layout');

                $('.wrapper-blog-grid').html('');

                $('.wrapper-blog-grid').attr('data-page', '1');

                if ($(this).val() == '*') {
                    var select_filter = $(this).val();
                } else {
                    var select_filter = '.' + $(this).val();
                }

                $('.js-radio-button-group .button').removeClass('is-checked');
                if ($(this).val() == '*') {
                    $('.js-radio-button-group .button').first().addClass('is-checked');
                } else {
                    $('.js-radio-button-group .button[data-filter='+$(this).val()+']').addClass('is-checked');
                }


                window.history.replaceState({}, document.title, location.protocol + '//' + location.host + location.pathname);
                $services_grid = $('.wrapper-blog-grid').isotope({filter: select_filter});

                // Add 
                var scrollLoadFlag = true;
                var blog_category = $('.services-cat-select').val();
                var data_page = '0';

                var data = {
                    'action' : 'load_more_post',
                    'blog_category' : blog_category,
                    'data_page' : data_page
                };

                console.log (data);

                $.ajax({
                    url: ajaxurl,
                    method: 'POST',
                    data: data,
                    dataType: "json",
                    success: function (response) {

                        if (response.success) {

                            if (response.data.html) {
                                if(response.data.page == '1') {
                                    // $('.wrapper-blog-grid').html(response.data.html);
                                } else {
                                    // $('.wrapper-blog-grid').append(response.data.html);
                                }
                                /*
                                $('.wrapper-blog-grid').isotope('destroy');

                                $('.wrapper-blog-grid').isotope({
                                    // options
                                    itemSelector: '.blog-grid-item',
                                    layoutMode: 'fitRows',
                    
                                });
                                */

                                var $newItems = $(response.data.html);
                                setTimeout(function() {
                                    $('.wrapper-blog-grid').append( $newItems ).isotope( 'appended', $newItems ).isotope( 'layout' );
                                }, 50); // fixes an overlay bug


                                // $('.wrapper-blog-grid').append(response.data.html).isotope('appended',response.data.html);

                                $('.wrapper-blog-grid').attr('data-page', response.data.page);


                            }
                        } else {

                        }
                    },
                    error: function (jqXHR) {
                        console.warn(jqXHR);
                    }
                });

            })


        }




        // CRM Page 

        if ($('.services-cat-select').length && $('.wrapper-crm-grid').length ) {

            // Initialise Isotope
            // Set the item selector
            var buttonFilter = '*';

            // console.log ('buttonFilter-' + buttonFilter);
            $(window).on('resize', function() {
                var $services_grid = $('.wrapper-crm-grid').isotope({
                    // options
                    itemSelector: '.crm-grid-item',
                    layoutMode: 'fitRows',
                    filter: buttonFilter
                });
            }); // fixes bug onload


            $('.services-cat-select').on('change', function() {
                if ($(this).val() == '*') {
                    var select_filter = $(this).val();
                } else {
                    var select_filter = '.' + $(this).val();
                }

                window.history.replaceState({}, document.title, location.protocol + '//' + location.host + location.pathname);
                $services_grid = $('.wrapper-crm-grid').isotope({filter: select_filter});
            })



            $('.js-loadmore, .services-cat-select').on('click change', function(e) {
                e.preventDefault();

                if (!$(this).hasClass('is-disabled')) {




                    var crm_container = $('.wrapper-crm-grid');
                    // Add 
                    var scrollLoadFlag = true;
                    var crm_category = $('.services-cat-select').val();
                    // var data_page = crm_container.data('page');
                    var data_page = crm_container.attr('data-page');
                    // var data_device = crm_container.data('device');
                    var data_device = crm_container.attr('data-device');
                    // var data_count = crm_container.data('count');
                    var data_count = crm_container.attr('data-count');
                    var data_lang_code = crm_container.attr('data-lang-code');



                    if(e.type==='change') {
                        data_page = 0;
                        data_count = 0;

                        $('.wrapper-crm-grid').isotope( 'remove', $('.crm-grid-item')).isotope('layout');

                    }


                    var data = {
                        'action' : 'load_more_crm',
                        'crm_category' : crm_category,
                        'data_page' : data_page,
                        'data_device' : data_device,
                        'data_count' : data_count,
                        'data_lang_code' : data_lang_code,
                    };

                    $.ajax({
                        url: ajaxurl,
                        method: 'POST',
                        data: data,
                        dataType: "json",
                        beforeSend: function(){
                            $('.js-loadmore').addClass('is-disabled');
                        },
                        success: function (response) {
                            // console.log(response);
                            if (response.success) {

                                // console.log (response.data);

                                if (response.data.html) {
                                    if(response.data.page == '1') {

                                        // $('.wrapper-crm-grid').isotope( 'remove', $('.crm-grid-item')).isotope('layout');

                                        var $newItems = $(response.data.html);
                                        $('.js-loadmore').show();
                                        setTimeout(function() {
                                            $('.wrapper-crm-grid').isotope({
                                                // options
                                                itemSelector: '.crm-grid-item',
                                                layoutMode: 'fitRows',
                                                filter: buttonFilter
                                            });
                                            $('.wrapper-crm-grid').append( $newItems ).isotope( 'appended', $newItems ).isotope( 'layoutItems', $newItems );
                                        }, 50); // fixes an overlay bug

                                    } else {
                                        var $newItems = $(response.data.html);
                                        $('.js-loadmore').hide();
                                        setTimeout(function() {
                                            $('.wrapper-crm-grid').isotope({
                                                // options
                                                itemSelector: '.crm-grid-item',
                                                layoutMode: 'fitRows',
                                                filter: buttonFilter
                                            });
                                            $('.wrapper-crm-grid').append( $newItems ).isotope( 'appended', $newItems ).isotope( 'layoutItems', $newItems );
                                        }, 50); // fixes an overlay bug
                                    }

                                    // console.log (response.data.page);

                                    $('.wrapper-crm-grid').attr('data-page', response.data.page);

                                    $('.wrapper-crm-grid').attr('data-count', response.data.items);


                                    if (response.data.page >= response.data.max_num_pages) {
                                        $('.js-loadmore').addClass('is-disabled');
                                        $('.js-loadmore').hide();
                                    } else {
                                        $('.js-loadmore').removeClass('is-disabled');
                                    }
                                    if (data_device != 'desktop') {
                                        $('.js-loadmore').addClass('unhovered');
                                    }


                                } else {
                                    $('.js-loadmore').addClass('is-disabled');
                                    $('.js-loadmore').hide();
                                }
                            } else {

                            }
                        },
                        error: function (jqXHR) {
                            console.warn(jqXHR);
                        }
                    });


                }

            });


        }
    }

})(jQuery);